module.exports = __webpack_public_path__ + "img/peifer-welding.d23777f8.jpg";